// react component

import React from "react";

const Tent = () => {
  return (
    <>
      <svg
        width="32"
        height="28"
        viewBox="0 0 26 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.8896 0.238382C12.9295 0.155566 13.0591 0.158408 13.0946 0.243221C13.4218 1.02443 14.6735 3.58932 18 6.5C22 10 25.9904 11.25 25.9904 11.25H0.00964355C0.00964355 11.25 4.5 9.5 8 6.5C10.9563 3.96603 12.4857 1.07533 12.8896 0.238382Z"
          fill="white"
        />
        <path
          d="M0 11.5C0 11.2239 0.223858 11 0.5 11H25.5C25.7761 11 26 11.2239 26 11.5V11.5C26 11.7761 25.7761 12 25.5 12H0.5C0.223858 12 0 11.7761 0 11.5V11.5Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24 12H2V23H6C6 23 8.41967 21.5741 10.3057 19.1296C12.1917 16.6852 13 13.8333 13 13.8333C13 13.8333 13.5388 16.2778 15.6943 19.1296C17.8497 21.9815 20 23 20 23H24V12Z"
          fill="white"
        />
      </svg>
    </>
  );
};

export default Tent;
